



































import { Component, Prop, Vue } from "vue-property-decorator";

import ToRateComponent from "./ToRate.vue";
import ToDoseComponent from "./ToDose.vue";

@Component({
  components: { "to-rate": ToRateComponent, "to-dose": ToDoseComponent },
})
export default class Calculator extends Vue {
  @Prop() readonly weightin!: number;
  @Prop() readonly agein!: number;
  @Prop() readonly colors!: { theme: string; light: string };

  private selectedComponent = "to-rate";
  private weight = 0;
  private age = 0;

  mounted(): void {
    this.weight = this.weightin;
    this.age = this.agein;
    console.log(this.colors);

    document.documentElement.style.setProperty(
      "--theme-color",
      this.colors.theme
    );
    document.documentElement.style.setProperty(
      "--light-color",
      this.colors.light
    );
  }
}
